// Navigation utility functions for passage planning

// Calculate distance between two points using haversine formula
export const calculateDistance = (lat1, lng1, lat2, lng2) => {
  const R = 3440.065; // Earth radius in nautical miles
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLng/2) * Math.sin(dLng/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
};

// Calculate bearing between two points
export const calculateBearing = (lat1, lng1, lat2, lng2) => {
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const lat1Rad = lat1 * Math.PI / 180;
  const lat2Rad = lat2 * Math.PI / 180;
  const y = Math.sin(dLng) * Math.cos(lat2Rad);
  const x = Math.cos(lat1Rad) * Math.sin(lat2Rad) -
            Math.sin(lat1Rad) * Math.cos(lat2Rad) * Math.cos(dLng);
  const bearing = Math.atan2(y, x) * 180 / Math.PI;
  return (bearing + 360) % 360;
};

// Format duration in hours to human readable format
export const formatDuration = (hours) => {
  if (hours < 1) return `${Math.round(hours * 60)} mins`;
  if (hours < 24) return `${hours.toFixed(1)} hrs`;
  const days = Math.floor(hours / 24);
  const remainingHours = Math.round(hours % 24);
  return `${days}d ${remainingHours}h`;
};

// Export passage plan as text file
export const exportPassagePlan = (plan, waypoints, routeStats, currentVessel) => {
  const planText = `
PASSAGE PLAN
============
Vessel: ${currentVessel?.vesselName || 'Unknown'}
Plan: ${plan.name}
Date: ${new Date().toLocaleDateString()}
Speed: ${plan.vesselSpeed} knots
Total Distance: ${routeStats.totalDistance.toFixed(1)} nm
Estimated Time: ${formatDuration(routeStats.totalTime)}

WAYPOINTS
---------
${waypoints.map((wp, i) => `
${wp.name}
Lat: ${wp.lat.toFixed(6)}° ${wp.lat >= 0 ? 'N' : 'S'}
Lng: ${wp.lng.toFixed(6)}° ${wp.lng >= 0 ? 'E' : 'W'}
${i > 0 ? `Distance: ${wp.distance?.toFixed(1)} nm` : ''}
${i > 0 ? `Bearing: ${Math.round(wp.bearing || 0)}°` : ''}
${wp.notes ? `Notes: ${wp.notes}` : ''}
`).join('\n')}

${plan.notes ? `NOTES\n-----\n${plan.notes}\n` : ''}
  `;

  const blob = new Blob([planText], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `passage_plan_${plan.name.replace(/\s+/g, '_')}.txt`;
  a.click();
  URL.revokeObjectURL(url);
};